/**
 * Generated by orval v8.16.0 🍺
 * Do not edit manually.
 * FinPath API
 * Backend API programu FinPath (panel admina + aplikacja mobilna).
 * OpenAPI spec version: 0.1.0
 */

/**
 * * `all_schools` - Wszystkie szkoły
 * * `selected_schools` - Wybrane szkoły
 * * `selected_classes` - Wybrane klasy
 */
export type ScopeKindEnum = typeof ScopeKindEnum[keyof typeof ScopeKindEnum];


export const ScopeKindEnum = {
  all_schools: 'all_schools',
  selected_schools: 'selected_schools',
  selected_classes: 'selected_classes',
} as const;
